import styled from '@emotion/styled';
import { palette, radius, shadow, spacing, transition, typography } from '../../../../style-utils/theme';
import { down } from '../../../../style-utils/media-queries';

/* The guide gallery's tiles (plan S7.8): the EntityGallery grid and square
   tile ground, with the controls under the photo rather than on a hover scrim
   — a tile here carries five of them, and a scrim of five would hide the
   photo it acts on. */

export const TileGrid = styled.ul`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: ${spacing.sm};
  margin: 0;
  padding: 0;
  list-style: none;

  ${down('sm')} {
    grid-template-columns: repeat(auto-fill, minmax(148px, 1fr));
  }
`;

export const TileCard = styled.li`
  display: flex;
  flex-direction: column;
  gap: ${spacing.xs};
  min-width: 0;
  padding: ${spacing.xs};
  border: 1px solid ${palette.line};
  border-radius: ${radius.md};
  background: ${palette.surface};
  box-shadow: ${shadow.xs};
  transition: ${transition.colors};

  &:focus-within {
    border-color: ${palette.teal};
  }
`;

export const TileFrame = styled.div`
  aspect-ratio: 1 / 1;
  border-radius: ${radius.sm};
  overflow: hidden;
  background: ${palette.surfaceMuted};
`;

export const TileTitle = styled.p`
  margin: 0;
  min-width: 0;
  font-family: ${typography.ui};
  font-size: ${typography.size.sm}px;
  font-weight: ${typography.weight.semibold};
  color: ${palette.ink};
  overflow-wrap: anywhere;
`;

export const TileMeta = styled.p`
  margin: 0;
  min-width: 0;
  font-family: ${typography.ui};
  font-size: ${typography.size.xs}px;
  color: ${palette.slate};
  overflow-wrap: anywhere;
`;

export const TileControls = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing.half};
  min-width: 0;
`;
